import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, [
      _createElementVNode("g", {
        stroke: "#191919",
        "stroke-width": ".65"
      }, [
        _createElementVNode("g", null, [
          _createElementVNode("g", null, [
            _createElementVNode("g", null, [
              _createElementVNode("path", { d: "M15.061 5.984a3.09 3.09 0 0 0-4.524 0 3.3 3.3 0 0 0-.536.78 3.3 3.3 0 0 0-.538-.78 3.095 3.095 0 0 0-4.526-.001 3.47 3.47 0 0 0 0 4.746L10 15.91l5.061-5.179a3.467 3.467 0 0 0 0-4.747" })
            ])
          ])
        ])
      ])
    ], -1)
  ])))
}
export default { render: render }